import { ApplicationState } from '../../../../store/types';
import { CompanyEntity } from '../../../admin/entity/store/types';
import { getDoraReportingRoot } from '../../store/selectors';
import { PreliminaryRoi } from './types';

export const getReportDownloading = (state: ApplicationState): boolean => getDoraReportingRoot(state).documentDownloading;

export const getPreliminaryRoi = (state: ApplicationState): PreliminaryRoi => getDoraReportingRoot(state).preliminaryRoi;

export const getEntitiesInScope = (state: ApplicationState): CompanyEntity[] => getDoraReportingRoot(state).entitiesInScope;

export const getSelectedInScopeEntity = (state: ApplicationState): CompanyEntity | null => getDoraReportingRoot(state).selectedInScopeEntity;
